<template>
  <save-modal :show="routeIsChange.length" position="bottom-right" @save="confirm" @cancel="cancel"/>
  <div class="content">
    <div class="search-block">
      
      <div class="search-bar">
        <label for="search" class="search-label">Поиск: </label>
        <input v-model="search" id="search" type="text" placeholder="Введите текст для поиска" />
      </div>
      
      <ATIButton button_type="switch" 
            v-model:show="show"
            active_button_text="Назад" inactive_button_text="Новый" class="test"> </ATIButton>

      <UploadRoutes />
      
    </div>
    <div class="route-table table">
      <table v-if="atiRoutes && !show" class="company-table">
        <thead>
          <tr>
            <th>Маршрут</th>
            <th>Ставка без НДС</th>
            <th>Ставка с НДС</th>
            <th>Удаление маршрута</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="route in filteredData" :key="route.id">
            <td>{{ route.route }}</td>
            <td><input class="number-input" :value="route.bid" type="number" @input="e=>updateAtiRoute(e,route.id)" name="bid"/></td>
            <td class="rate-sum">
              <input class="number-input" :value="route.bid_tax" type="number" @input="e=>updateAtiRoute(e,route.id)" name="bid_tax"/>
            </td>
            <td><button class="delete-button hover" @click="deleteRoute(route.id)" >Удалить</button></td>
          </tr>
        </tbody>
      </table>
      
      <NewAtiRouteForm v-else :initialRoute="pendingInitialRoute" @add-route="addNewRoute" />
    </div>

  </div>
</template>


<script>
import { computed,onMounted,ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import AtiRouteListTable from './components/AtiRouteListTable.vue';
import NewAtiRouteForm from './components/NewAtiRouteForm.vue';
import ATIButton from './components/ATIButtonComponent.vue';
import UploadRoutes from '@/pages/ati/components/UploadRoutes'

export default {
  components: {
    AtiRouteListTable,
    NewAtiRouteForm,
    ATIButton,
    UploadRoutes
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const atiRoutes = computed(()=>store.state.ati.routes)
    const routeIsChange = computed(()=> store.getters['ati/changedRoutes'])
    const search = ref('');
    const show = ref(false)
    const pendingInitialRoute = ref('')

    const filteredData = computed(() => {
      // Если строка поиска пуста, возвращаем все записи
      if (!search.value.trim()) {
        return atiRoutes.value;
      }

      // Иначе фильтруем записи по строке поиска
      const searchLower = search.value.trim().toLowerCase();
      return atiRoutes.value.filter((route) => route.route.toLowerCase().includes(searchLower));
    });

    onMounted(async () => {
      await store.dispatch('ati/getRoutes')
      // Deep-link: если в URL есть ?route=Город1-Город2
      const queryRoute = route.query.route
      if (queryRoute && typeof queryRoute === 'string') {
        search.value = queryRoute
        const exists = store.getters['ati/getRouteId'](queryRoute)
        // Открыть форму создания если маршрута нет или явный флаг new=1
        if (!exists || route.query.new === '1') {
          pendingInitialRoute.value = queryRoute
          show.value = true
        }
      }
    })

    const addNewRoute = (form) => {
      store.dispatch('ati/addNewRoute',{form})
      show.value = false
    }

    const deleteRoute =(id)=>{
      store.dispatch('ati/deleteRoute',{id})
    }

    const confirm = ()=>{
      store.dispatch('ati/updateRouteBid')
    }

    const cancel = async ()=>{
      await store.dispatch('ati/getRoutes')
    }

    const updateAtiRoute = (event,id)=>{
      store.commit('ati/changeWithoutUpdate',{id,value:event.target.value,name:event.target.name})
    }
    
    return {
      updateAtiRoute,
      addNewRoute,
      show,
      search,
      filteredData,
      deleteRoute,
      routeIsChange,
      confirm,
      cancel,
      atiRoutes,
      pendingInitialRoute,
    };
  },
}
</script>

<style scoped>
.content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table{
  font-size: 14px;
  margin-top: 20px;
  width: 650px;
}

.search-block {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar{
  margin-right: 110px;
}

#search{
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 200px;
}

.company-table {
    margin-right: 20px;
    border-collapse: collapse;
  }

  .company-table th {
    text-align: center;
    padding: 10px;
    border: 1px solid #ccc;
  }

  .company-table td {
    text-align: center;
    padding: 3px;
    font-size: 12px;
    border: 1px solid #ccc;
  }

  .company-table th {
    font-weight: bold;
  }

  .rate-sum{
    min-width: 100px;
  }

  .number-input {
    width: 65px;
  }

  .delete-button{
    padding: 2px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

  .hover:hover {
    cursor: pointer;
  }

@media screen and (max-width: 769px) {
  .search-block {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

